module.exports = __webpack_public_path__ + "img/metroidvania05.a6da2780.jpg";